import { useEffect } from 'react';

const handleBeforeUnload = (e: BeforeUnloadEvent) => {
  e.preventDefault();
  e.returnValue = ''; // required by Chrome browser
  return true;
};

export const useBeforeUnloadWarning = (showWarning: boolean) => {
  useEffect(() => {
    if (showWarning) {
      window.addEventListener('beforeunload', handleBeforeUnload, true);
    } else {
      window.removeEventListener('beforeunload', handleBeforeUnload, true);
    }

    return function cleanup() {
      window.removeEventListener('beforeunload', handleBeforeUnload, true);
    };
  }, [showWarning]);
};
